import "./lavoraConNoiMobile.css";
import data from "../../utils/data.json";
import { useLanguage } from "../../context/LanguageContext";
import logo from "../../utils/imgs/logos/logo_y.png";

const LavoraConNoiMobile = ({ setLavoraConNoiMobile }) => {

  /* ------ Context API ------ */
  const { selectedLanguage } = useLanguage();
  const content = data?.lavoraConNoi?.[selectedLanguage];

  const orientation = window.screen.orientation?.type;
  const isPortrait  = orientation?.startsWith("portrait");
  const isLandscape = orientation?.startsWith("landscape");

  const extraContentPortrait  = window.innerWidth >= 359 && isPortrait;
  const extraContentLandscape = window.innerWidth >= 843 && isLandscape;

  const closeSection = () => {
    setLavoraConNoiMobile(false);
    window.onscroll = function () {};
  };

  return (   
    <div id="lavora_con_noi-mobile" >

      <div className="bar-mobile" />

      <div className="logo-title-mobile">
        <div className="logo-container-mobile">
          <img src={logo} alt="logo" />
        </div>
        <h3 className="title_lcn-mobile">{content?.title}</h3>
      </div>

      <div className="lcn-mobile">
        <div className="lavoraConNoi-mobile">

          <p>{content?.text1}</p>

          <p className="mailto-mobile">
            {content?.text2}&nbsp;
            <a href={`mailto:${content?.mail}`}>{content?.mail}</a>
          </p>

          {(extraContentPortrait || extraContentLandscape) && (
            <>
              <p className="extra-content">{content?.text3}</p>

              <ul>
                {content?.bulletPoints?.map(point => (
                  <li>{point}</li>
                ))}
              </ul>
            </>
          )}

        </div>
      </div>

      <div className="btn_container-mobile">
        <button onClick={closeSection}>OK</button>
      </div>

    </div>
  );
}

export default LavoraConNoiMobile;
